import { useContext, useEffect } from "react";
import $ from "jquery";
import "metismenu";
import { MetisMenu } from "./styles";
import DashboardManage from "../menus/DashboardManage";
import UserManage from "../menus/UserManage";
import ContentManage from "../menus/ContentManage";
import WebsiteManage from "../menus/WebsiteManage";
import ProductManage from "../menus/ProductManage";
import StockManage from "../menus/StockManage";
import PermissionContext from "../../store/PermissionContext";
import { Spinner } from "react-bootstrap";

const NavMenu = () => {
      const permissionCtx = useContext(PermissionContext);

      useEffect(() => {
            $("#menu").metisMenu();
      });

      return (
            <>
                  {!permissionCtx?.loading ? (
                        <MetisMenu className="metismenu" id="menu">
                              <DashboardManage />

                              <UserManage />

                              <ProductManage />

                              <WebsiteManage />
                              <ContentManage />
                              <StockManage />
                        </MetisMenu>
                  ) : (
                        <>
                              <Spinner />
                        </>
                  )}
            </>
      );
};

export default NavMenu;
